import axios from "../../../../utils/axios-private";
export const getVillages = () => {
  return {
    type: "GET_DROPDOWN_VILLAGES",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/databasic/desa`;
      axios
        .get(url, { signal: controller.signal })
        .then((response) => {
          resolve({ response });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
